import { useState } from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap"

type TProps = {
    nameOnID: string,
    availableList: { label: string; name: string }[],
    setPersonIndex: (index: number) => void,
    handleConfirm: () => void,
    handleClose: () => void,
}

const IDVImportMatching = (props: TProps) => {
    const [validated, setValidated] = useState<boolean>(false);
    return (
        <Modal show={true} onHide={props.handleClose}>
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter" >Link ID Verification</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Row>
                    <Col>{props.nameOnID}</Col>
                </Row>
                <Row>
                    <Col>
                        link to
                        <Form>
                            <Form.Select
                                onChange={(e) => {
                                    if (e.target.value > "") {
                                        props.setPersonIndex(Number(e.target.value))
                                    }
                                    setValidated(e.target.value > "");
                                }}>
                                <option value="">- Select -</option>
                                {props.availableList.map((option, index) =>
                                    <option key={`IDVImport-option${index}`} value={index}>{option.label}</option>
                                )}
                            </Form.Select>
                        </Form>
                    </Col>
                </Row>
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={props.handleClose} variant="text">Cancel</Button>
                <Button disabled={!validated} onClick={props.handleConfirm}>Accept</Button>
            </Modal.Footer>
        </Modal>
    )
}

export default IDVImportMatching;